/// <reference path="../Controller.ts" />
/// <reference path="../../HTML/Navigation/UserItem.ts" />
namespace HA.Core.Controller.Navigation {
    import UserItem = HA.Core.HTML.Navigation.UserItem;

    export class NavigationUser extends NavigationItem {

        public updateUser(data: Map<any, any>) {
            if (data.has("picture")) {
                this.getTag().updateImage(toMap({src: data.get("picture")}));
                if (data.get("picture") !== "/file/ha/svg/user") {
                    this.getTag().isConnected();
                } else {
                    this.getTag().disconnected();
                }
            }
        }

        protected subscribeToUser() {
            const me = this;
            this.getUserService().subscribe( (data: Map<any, any>) => {
                me.updateUser(data);
            });
        }

        protected getUserService(): HA.Core.Service.User {
            return this.getService("ha.service.user");
        }

        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            this.subscribeToUser();
        }

        protected createTag(data: any) {
            this.addToData("tag", new UserItem(data));
        }
    }
}
